import EditCell from "../../../../components/custom/merchandise/cells/CommonEditCell";
import type { Column } from "react-table-6";
import getMetricSpec, { type MetricLabel } from "../../utils/metrics";
import { MetricLabel as MetricLabelText } from "../../../../components/i18n/MetricLabel";

export interface EditColumnOptions {
  columnTitle?: MetricLabel | string;
  editCell: true;
  isStatic?: boolean;
  format?: string;
  validations?: {
    minValue?: number;
    maxValue?: number;
    blank?: boolean;
    compare?: { key: string; operator: "lessThan" | "greaterThan"; message: string };
  };
  toolTip: string;
  tabIndex?: number;
  overrideKey?: string;
  onValue?: string;
  offValue?: string;
  width?: number;
  className?: string;
  headerClassName?: string;
  toggleAction?: (row: unknown, updateValue: number | string | undefined) => void;
  strikeThroughText?: ((row: unknown) => string) | undefined;
  checked?: boolean;
  renderPlaceholderCellContent?: (row: unknown) => boolean;
  disabled?: boolean;
  getCellDisabled?: (row: unknown) => boolean;
}

interface EditColumn extends Column {
  checked: boolean;
  isStatic?: boolean;
  grouping?: string;
  format?: string;
  height: number;
  onValue?: string;
  offValue?: string;
  toolTip: string;
  id: string;
  name?: MetricLabel | string;
}

const buildEditColumn = (
  title: MetricLabel | string,
  marketPlace: { marketPlace: string },
  id: string,
  options: EditColumnOptions,
): EditColumn => {
  const { width, isStatic, checked, format, onValue, offValue, toolTip } = options;
  const metricSpec = getMetricSpec(id);

  return {
    Header: <MetricLabelText label={title} />,
    name: title,
    id,
    accessor: id,
    checked: checked ?? true,
    isStatic,
    grouping: metricSpec.grouping,
    width,
    format,
    height: 30,
    onValue,
    offValue,
    toolTip,
    className: options.className,
    headerClassName: options.className,
    Cell: (props) => {
      const { row, column } = props;
      return (
        <EditCell
          row={row}
          value={
            options.overrideKey && row?._original?.[options.overrideKey] && !row?._original?.updated ?
              row?._original?.[options.overrideKey]
            : row?._original?.[column.id!]
          }
          column={column}
          options={options}
          marketPlace={marketPlace}
        />
      );
    },

    style: { height: "60px" },
  };
};

export default buildEditColumn;
